import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=7d386775&scoped=true&"
import script from "./HistoryPage.vue?vue&type=script&lang=js&"
export * from "./HistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d386775",
  null
  
)

export default component.exports